<main>
  <p style="text-align: center">
    You are now logged out.
  </p>
  <div class="embed-container">
    <iframe class="iframe-embed" frameBorder="0" title="marketing" src="https://landing-embed.zint.io/"></iframe>
  </div>
</main>
